import type { CellValue, ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

import type { FilterOperatorDto } from '@src/api';

export const getColumns = (
  filterOperators: FilterOperatorDto[],
  sourceFields: { id: string; name: string }[],
): ColumnInterface[] => [
  {
    title: 'Номер правила',
    key: 'orGroup',
  },
  {
    title: 'Последовательность условий в правиле',
    key: 'andGroup',
  },
  {
    title: 'Фильтр: Имя поля',
    key: 'fieldName',
    render: ({ value }: { value: CellValue }): JSX.Element | CellValue =>
      sourceFields.find((field) => field.id === value)?.name,
  },
  {
    title: 'Фильтр: Опция',
    key: 'selOption',
    render: ({ value }: { value: CellValue }): JSX.Element | CellValue => {
      const operator = filterOperators.find((type) => type.code === value);
      return operator ? `${operator.code} - ${operator.name}` : '';
    },
  },
  {
    title: 'Фильтр: Значение',
    key: 'fieldValue',
  },
];
